module.exports = __webpack_public_path__ + "media/images/icons/outlined/block-1039974d3e32f70cd8885b333cbfd57c.svg";